<script>
  export let isOpen;
</script>

<!-- Icons copied from https://heroicons.com/ -->
{#if isOpen}
  <!-- X -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="h-24 w-24"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    stroke-width="2"
  >
    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
  </svg>
{:else}
  <!-- Hamburger -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="h-24 w-24"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    stroke-width="2"
  >
    <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
  </svg>
  <!-- End Hamburger-->
{/if}
